// extracted by mini-css-extract-plugin
export default {"wrapper":"RfqUpload_wrapper__18zmr"};